<template>
  <div class="knowledge-news">
    <div class="top-content">
      <h1 class="top-content-title">{{ $t('knowledge.banner_news') }}</h1>
      <p class="top-content-desc">
        {{ $t('knowledge.banner_news_desc') }}
      </p>
    </div>
    <div class="news-content">
      <div v-show="false">
        <div v-for="item in newsList" :key="item.key">
          {{ $t(item.label) }}

          <div
            v-if="item.list && item.list.length > 0"
            class="flex flex-col space-y-2"
          >
            <a
              v-for="newsItem in item.list.slice(0, 1)"
              :key="newsItem.id"
              class="shadow-contact-us-banner bg-white rounded-lg min-h-[267px] p-2 flex flex-col relative"
              :href="
                getLineHref(
                  `/${getNewsPathPrefix(activeType)}/${newsItem.id}/`,
                  isCn ? '/cn' : '/en',
                )
              "
              @click.prevent="toNewsDetail(newsItem, item.key)"
            >
              <JcImg :level="1"
                v-if="
                  getCnOrEn(
                    newsItem.coverPictureFileCnUrl,
                    newsItem.coverPictureFileUrl,
                  )
                "
                :src="
                  getCnOrEn(
                    newsItem.coverPictureFileCnUrl,
                    newsItem.coverPictureFileUrl,
                  )
                "
                :alt="
                  isCn
                    ? newsItem?.kcn?.split(/;|；/)[0]
                    : newsItem?.ken?.split(/;|；/)[0]
                "
                class="w-full h-[184px] shrink-0 object-contain"
              />
              <div v-else class="w-full h-[184px] shrink-0" />

              <p
                class="truncate font-popB text-paper text-[15px] leading-5 font-bold mt-2"
              >
                {{ getCnOrEn(newsItem.titleCn, newsItem.title) }}
              </p>

              <div class="news-tag text-center my-2 flex-c">
                {{ $t(item.label) }}
              </div>

              <p
                class="truncate font-popR text-paper-200 font-normal leading-[13px] text-[11px] mt-auto"
              >
                {{
                  filterContent(
                    getCnOrEn(
                      newsItem.contentCn || newsItem.content,
                      newsItem.content || newsItem.contentCn,
                    ),
                  )
                }}
              </p>

              <p
                class="font-popR text-paper-300 text-[10px] leading-[18px] font-normal mt-auto"
              >
                {{
                  $dayjs(newsItem.auditTime)
                    .locale(isCn ? 'zh-CN' : 'en-US')
                    .format(isCn ? 'YYYY-MM-DD' : 'D-MMM-YYYY')
                }}
              </p>
              <i
                class="iconfont icon-a-right_line2 absolute right-2 bottom-10 !text-sm text-paper-100"
              />
            </a>
            <a
              v-for="newsItem in item.list.slice(1)"
              :key="newsItem.id"
              class="shadow-contact-us-banner bg-white rounded-lg min-h-20 p-2 flex relative"
              :href="
                getLineHref(
                  `/${getNewsPathPrefix(activeType)}/${newsItem.id}/`,
                  isCn ? '/cn' : '/en',
                )
              "
              @click.prevent="toNewsDetail(newsItem, item.key)"
            >
              <i
                class="iconfont icon-a-right_line2 absolute right-2 bottom-2 !text-sm text-paper-100"
              />
              <div class="flex-c flex-col">
                <JcImg :level="1"
                  v-if="
                    getCnOrEn(
                      newsItem.coverPictureFileCnUrl,
                      newsItem.coverPictureFileUrl,
                    )
                  "
                  :src="
                    getCnOrEn(
                      newsItem.coverPictureFileCnUrl,
                      newsItem.coverPictureFileUrl,
                    )
                  "
                  :alt="getCnOrEn(newsItem.titleCn, newsItem.titleEn)"
                  class="w-[112px] h-[63px] shrink-0 object-contain"
                />
                <div v-else class="w-[112px] h-[63px] shrink-0" />
                <div class="news-tag text-center mt-2 flex-c">
                  {{ $t(item.label) }}
                </div>
              </div>
              <div class="flex-1 ml-2 truncate flex flex-col">
                <p
                  class="truncate font-popB text-paper text-[15px] leading-5 font-bold"
                >
                  {{ getCnOrEn(newsItem.titleCn, newsItem.title) }}
                </p>
                <p
                  class="truncate font-popR text-paper-200 font-normal leading-[13px] text-[11px]"
                >
                  {{
                    filterContent(
                      getCnOrEn(
                        newsItem.contentCn || newsItem.content,
                        newsItem.content || newsItem.contentCn,
                      ),
                    )
                  }}
                </p>

                <p
                  class="font-popR text-paper-300 text-[10px] leading-[18px] font-normal mt-auto"
                >
                  {{
                    $dayjs(newsItem.auditTime)
                      .locale(isCn ? 'zh-CN' : 'en-US')
                      .format(isCn ? 'YYYY-MM-DD' : 'D-MMM-YYYY')
                  }}
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>

      <van-tabs
        v-model:active="modelValue"
        :line-height="0"
        type="card"
        class="news-main-tab"
        :title-active-color="'#ff6a00'"
        title-inactive-color="#5e5f64"
        :color="'#ff6a001a'"
        swipe-threshold="2"
        @click-tab="changeTab"
      >
        <van-tab
          v-for="item in newsList"
          :key="item.key"
          :title="$t(item.label)"
          :title-class="'asdasdasdas'"
        >
          <van-tabs
            v-model:active="currentSelectedTag"
            line-height="2"
            class="mt-2 mb-2"
            swipe-threshold="3"
            title-active-color="#ff6600"
            :style="{
              '--van-tabs-bottom-bar-color': '#ff8800',
            }"
            @click-tab="handleClickTag"
          >
            <van-tab key="ALL" name="all" :title="getCnOrEn('全部', 'ALL')" />
            <van-tab
              v-for="(tagItem, index) in buttons"
              :key="index"
              :name="tagItem.id"
              :title="getCnOrEn(tagItem.keywordCn, tagItem.keywordEn)"
            />
          </van-tabs>
          <div
            v-if="item.list && item.list.length > 0"
            class="flex flex-col space-y-2"
          >
            <a
              v-for="newsItem in item.list.slice(0, 1)"
              :key="newsItem.id"
              class="shadow-contact-us-banner bg-white rounded-lg min-h-[267px] p-2 flex flex-col relative"
              :href="
                getLineHref(
                  `/${getNewsPathPrefix(activeType)}/${newsItem.id}/`,
                  isCn ? '/cn' : '/en',
                )
              "
              @click.prevent="toNewsDetail(newsItem, item.key)"
              v-gio-track="{
                event: 'clickPage',
                attrs: {
                  pageCode_var: route.meta.pageCode,
                  modulePosition_var: '-',
                  moduleType_var: '-',
                  moduleName_var: $t(item.label, {}, { locale: 'zh-CN' }),
                  pageClickName_var: newsItem.titleCn,
                  $title: '-',
                },
              }"
            >
              <JcImg :level="1"
                v-if="
                  getCnOrEn(
                    newsItem.coverPictureFileCnUrl,
                    newsItem.coverPictureFileUrl,
                  )
                "
                :src="
                  getCnOrEn(
                    newsItem.coverPictureFileCnUrl,
                    newsItem.coverPictureFileUrl,
                  )
                "
                :alt="
                  isCn
                    ? newsItem?.kcn?.split(/;|；/)[0]
                    : newsItem?.ken?.split(/;|；/)[0]
                "
                class="w-full h-[184px] shrink-0 object-contain"
              />
              <div v-else class="w-full h-[184px] shrink-0" />

              <p
                class="truncate font-popB text-paper text-[15px] leading-5 font-bold mt-2"
              >
                {{ getCnOrEn(newsItem.titleCn, newsItem.title) }}
              </p>

              <div class="news-tag text-center my-2 flex-c">
                {{ $t(item.label) }}
              </div>

              <p
                class="truncate font-popR text-paper-200 font-normal leading-[13px] text-[11px] mt-auto"
              >
                {{
                  filterContent(
                    getCnOrEn(
                      newsItem.contentCn || newsItem.content,
                      newsItem.content || newsItem.contentCn,
                    ),
                  )
                }}
              </p>

              <p
                class="font-popR text-paper-300 text-[10px] leading-[18px] font-normal mt-auto"
              >
                {{
                  $dayjs(newsItem.auditTime)
                    .locale(isCn ? 'zh-CN' : 'en-US')
                    .format(isCn ? 'YYYY-MM-DD' : 'D-MMM-YYYY')
                }}
              </p>
              <i
                class="iconfont icon-a-right_line2 absolute right-2 bottom-10 !text-sm text-paper-100"
              />
            </a>
            <a
              v-for="newsItem in item.list.slice(1)"
              :key="newsItem.id"
              class="shadow-contact-us-banner bg-white rounded-lg min-h-20 p-2 flex relative"
              :href="
                getLineHref(
                  `/${getNewsPathPrefix(activeType)}/${newsItem.id}/`,
                  isCn ? '/cn' : '/en',
                )
              "
              @click.prevent="toNewsDetail(newsItem, item.key)"
              v-gio-track="{
                event: 'clickPage',
                attrs: {
                  pageCode_var: route.meta.pageCode,
                  modulePosition_var: '-',
                  moduleType_var: '-',
                  moduleName_var: $t(item.label, {}, { locale: 'zh-CN' }),
                  pageClickName_var: newsItem.titleCn,
                  $title: '-',
                },
              }"
            >
              <i
                class="iconfont icon-a-right_line2 absolute right-2 bottom-2 !text-sm text-paper-100"
              />
              <div class="flex-c flex-col">
                <JcImg :level="1"
                  v-if="
                    getCnOrEn(
                      newsItem.coverPictureFileCnUrl,
                      newsItem.coverPictureFileUrl,
                    )
                  "
                  :src="
                    getCnOrEn(
                      newsItem.coverPictureFileCnUrl,
                      newsItem.coverPictureFileUrl,
                    )
                  "
                  :alt="getCnOrEn(newsItem.titleCn, newsItem.titleEn)"
                  class="w-[112px] h-[63px] shrink-0 object-contain"
                />
                <div v-else class="w-[112px] h-[63px] shrink-0" />
                <div class="news-tag text-center mt-2 flex-c mr-auto">
                  {{ $t(item.label) }}
                </div>
              </div>
              <div class="flex-1 ml-2 truncate flex flex-col">
                <p
                  class="truncate font-popB text-paper text-[15px] leading-5 font-bold"
                >
                  {{ getCnOrEn(newsItem.titleCn, newsItem.title) }}
                </p>
                <p
                  class="truncate font-popR text-paper-200 font-normal leading-[13px] text-[11px]"
                >
                  {{
                    filterContent(
                      getCnOrEn(
                        newsItem.contentCn || newsItem.content,
                        newsItem.content || newsItem.contentCn,
                      ),
                    )
                  }}
                </p>

                <p
                  class="font-popR text-paper-300 text-[10px] leading-[18px] font-normal mt-auto"
                >
                  {{
                    $dayjs(newsItem.auditTime)
                      .locale(isCn ? 'zh-CN' : 'en-US')
                      .format(isCn ? 'YYYY-MM-DD' : 'D-MMM-YYYY')
                  }}
                </p>
              </div>
            </a>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useScroll } from '@vueuse/core'
  import { getNewsList, getTagList } from '~/api/news'
  import { NEW_ROUTE_MAP } from './constant'
  import { reportCallBack } from '~/api/system'

  const { t: $t } = useI18n()
  const { locale } = useI18n()
  const route = useRoute()
  const activeType = ref(route.meta?.type || 'logisticsNews')
  const modelValue = ref(0)
  const buttons = useState<any[]>('newButtons', () => [])
  const currentSelectedTag = useState<any>('currentSelectedTag', () => 'all')
  const { $trackEvent } = useNuxtApp()
  const systemStore = useMySystemStore()
  const buildTagPath = (base = '', tagSlug = '') => {
    const baseTrim = String(base || '').replace(/\/$/, '')
    if (!tagSlug) return `${baseTrim}/`
    return `${baseTrim}-${tagSlug}/`
  }
  const normalizeToSlug = (input = '') => {
    try {
      input = decodeURIComponent(String(input))
    } catch (e) {
      input = String(input || '')
    }
    return input
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_+|_+$/g, '')
  }
  const normalizePath = (path = '') => {
    try {
      path = decodeURIComponent(String(path))
    } catch {}
    return path.replace(/\/+$/, '').replace(/\/{2,}/g, '/')
  }
  type NewsTabKey =
    | 'logisticsNews'
    | 'jctransNews'
    | 'knowledgeNews'
    | 'regionsNews'
    | 'experienceNews'
    | 'solutionsNews'
    | 'policyNews'

  function getTabStateFromRoute(): {
    activeType: NewsTabKey
    modelValue: number
  } {
    const metaType = route.meta?.type
    if (metaType === 'jctransNews')
      return { activeType: 'jctransNews', modelValue: 1 }
    if (metaType === 'knowledge')
      return { activeType: 'knowledgeNews', modelValue: 2 }
    if (metaType === 'knowledge_area')
      return { activeType: 'regionsNews', modelValue: 3 }
    if (metaType === 'knowledge_experience')
      return { activeType: 'experienceNews', modelValue: 4 }
    if (metaType === 'knowledge_solutions')
      return { activeType: 'solutionsNews', modelValue: 5 }
    if (metaType === 'knowledge_policy')
      return { activeType: 'policyNews', modelValue: 6 }

    const routeName = String(route.name || '')
    const byName: Record<
      string,
      { activeType: NewsTabKey; modelValue: number }
    > = {
      jctransNews: { activeType: 'jctransNews', modelValue: 1 },
      JctransNewsDetail: { activeType: 'jctransNews', modelValue: 1 },
      tagJctransNews: { activeType: 'jctransNews', modelValue: 1 },
      knowledgeNews: { activeType: 'knowledgeNews', modelValue: 2 },
      knowledgeNewsDetail: { activeType: 'knowledgeNews', modelValue: 2 },
      tagKnowledgeNews: { activeType: 'knowledgeNews', modelValue: 2 },
      regionsNews: { activeType: 'regionsNews', modelValue: 3 },
      regionsNewsDetail: { activeType: 'regionsNews', modelValue: 3 },
      tagRegionsNews: { activeType: 'regionsNews', modelValue: 3 },
      experienceNews: { activeType: 'experienceNews', modelValue: 4 },
      experienceNewsDetail: { activeType: 'experienceNews', modelValue: 4 },
      tagExperienceNews: { activeType: 'experienceNews', modelValue: 4 },
      solutionsNews: { activeType: 'solutionsNews', modelValue: 5 },
      solutionsNewsDetail: { activeType: 'solutionsNews', modelValue: 5 },
      tagSolutionsNews: { activeType: 'solutionsNews', modelValue: 5 },
      policyNews: { activeType: 'policyNews', modelValue: 6 },
      policyNewsDetail: { activeType: 'policyNews', modelValue: 6 },
      tagPolicyNews: { activeType: 'policyNews', modelValue: 6 },
      logisticsNews: { activeType: 'logisticsNews', modelValue: 0 },
      logisticsNewsDetail: { activeType: 'logisticsNews', modelValue: 0 },
      tagLogisticsNews: { activeType: 'logisticsNews', modelValue: 0 },
    }
    return byName[routeName] || { activeType: 'logisticsNews', modelValue: 0 }
  }

  function syncTabFromRoute() {
    const next = getTabStateFromRoute()
    const typeChanged = activeType.value !== next.activeType
    activeType.value = next.activeType
    modelValue.value = next.modelValue
    return typeChanged
  }

  syncTabFromRoute()

  const { x, y, arrivedState } = useScroll(document)
  const { left, right, top, bottom } = toRefs(arrivedState)
  const { getLineHref } = useLineHref()

  const loadStatus = ref(false)
  const logisticsParams = useState('logisticsParams', () => ({
    current: 1,
    size: 6,
    total: 0,
    keywordId: null,
  }))
  const jctransParams = useState('jctransParams', () => ({
    current: 1,
    size: 6,
    total: 0,
    keywordId: null,
  }))
  const knowledgeParams = useState('knowledgeParams', () => ({
    current: 1,
    size: 6,
    total: 0,
    keywordId: null,
  }))

  // 这里改动了：新增了 4 种分类的请求参数管理
  const regionsParams = useState('regionsParams', () => ({
    current: 1,
    size: 6,
    total: 0,
    keywordId: null,
  }))
  const experienceParams = useState('experienceParams', () => ({
    current: 1,
    size: 6,
    total: 0,
    keywordId: null,
  }))
  const solutionsParams = useState('solutionsParams', () => ({
    current: 1,
    size: 6,
    total: 0,
    keywordId: null,
  }))
  const policyParams = useState('policyParams', () => ({
    current: 1,
    size: 6,
    total: 0,
    keywordId: null,
  }))

  type TabItem = {
    label: string
    content: string
    list: any[]
    key: string
  }

  // 这里改动了：扩展了 tabs 列表，将所有细分分类加进去以渲染全部 Tag
  const newsList = useState<TabItem[]>('newsList', () => [
    {
      label: 'knowledge.logistics_news',
      content: '',
      list: [],
      key: 'logisticsNews',
    },
    {
      label: 'knowledge.jctrans_news',
      content: '',
      list: [],
      key: 'jctransNews',
    },
    {
      label: 'knowledge.freight_knowledge',
      content: '',
      list: [],
      key: 'knowledgeNews',
    },
    {
      label: 'knowledge.freight_area',
      content: '',
      list: [],
      key: 'regionsNews',
    },
    {
      label: 'knowledge.freight_experience',
      content: '',
      list: [],
      key: 'experienceNews',
    },
    {
      label: 'knowledge.freight_solutions',
      content: '',
      list: [],
      key: 'solutionsNews',
    },
    {
      label: 'knowledge.freight_policy',
      content: '',
      list: [],
      key: 'policyNews',
    },
  ])

  const isCn = computed(() => locale.value === 'zh-CN')
  const prefix = computed(() => (isCn.value ? '/cn' : '/en'))

  // 这里改动了：新增提取所有分类的路由路径前缀
  const getNewsPathPrefix = (type: string) => {
    if (type === 'jctransNews') return 'jctransnews'
    if (type === 'knowledgeNews') return 'news-knowledge'
    if (type === 'regionsNews') return 'news-regions'
    if (type === 'experienceNews') return 'news-experience'
    if (type === 'solutionsNews') return 'news-solutions'
    if (type === 'policyNews') return 'news-policy'
    return 'news'
  }

  async function getTagData() {
    const result = await $fetch('/api/newsTag', {
      method: 'post',
      timeout: 120000,
    })
    if (result && result?.data) {
      buttons.value = result.data.records
      const tag = route.params.tag

      if (tag) {
        const normTag = normalizeToSlug(String(tag))
        const currentTag = buttons.value.find((button) => {
          const en = normalizeToSlug(String(button.keywordEn || ''))
          return en === normTag
        })

        currentSelectedTag.value = currentTag ? currentTag.id : 'all'
        logisticsParams.value.keywordId = currentSelectedTag.value
        jctransParams.value.keywordId = currentSelectedTag.value
        knowledgeParams.value.keywordId = currentSelectedTag.value
        // 这里改动了：同步更新新加分类的 tag 参数
        regionsParams.value.keywordId = currentSelectedTag.value
        experienceParams.value.keywordId = currentSelectedTag.value
        solutionsParams.value.keywordId = currentSelectedTag.value
        policyParams.value.keywordId = currentSelectedTag.value
      } else {
        currentSelectedTag.value = 'all'
        reset()
      }
    }
  }

  // --- 通用获取数据的封装 ---
  const fetchNewsForList = async (
    paramsObj: any,
    typeVal: string,
    listIndex: number,
  ) => {
    const params = {
      ...paramsObj,
      type: typeVal,
      language: isCn.value ? 'cn' : 'en',
      keywordId: paramsObj.keywordId === 'all' ? '' : paramsObj.keywordId,
    }
    const res = await $fetch('/api/newsList', {
      method: 'POST',
      timeout: 120000,
      body: params,
    })
    if (res && res.data.records) {
      newsList.value[listIndex]!.list.push(...(res.data?.records || []))
      paramsObj.size = res.data?.size
      paramsObj.total = res.data?.total
      loadStatus.value = true
    }
  }

  // --- 各列表请求定义 ---
  async function getLogisticsNews() {
    await fetchNewsForList(logisticsParams.value, '2', 0)
  }
  async function getJctransNews() {
    await fetchNewsForList(jctransParams.value, '3', 1)
  }
  async function getKnowledgeNews() {
    await fetchNewsForList(knowledgeParams.value, '4', 2)
  }
  async function getRegionsNews() {
    await fetchNewsForList(regionsParams.value, '5', 3)
  }
  async function getExperienceNews() {
    await fetchNewsForList(experienceParams.value, '6', 4)
  }
  async function getSolutionsNews() {
    await fetchNewsForList(solutionsParams.value, '7', 5)
  }
  async function getPolicyNews() {
    await fetchNewsForList(policyParams.value, '8', 6)
  }

  async function getNewsTime(type = 'logisticsNews') {
    if (type === 'logisticsNews') await getLogisticsNews()
    else if (type === 'jctransNews') await getJctransNews()
    else if (type === 'knowledgeNews') await getKnowledgeNews()
    // 这里改动了：在统筹口增加调用支持
    else if (type === 'regionsNews') await getRegionsNews()
    else if (type === 'experienceNews') await getExperienceNews()
    else if (type === 'solutionsNews') await getSolutionsNews()
    else if (type === 'policyNews') await getPolicyNews()
  }

  // 外链/Header 跳转时组件复用，需根据路由同步 Tab
  watch(
    () => [route.name, route.meta?.type] as const,
    async (_newVal, oldVal) => {
      if (!oldVal) return
      const typeChanged = syncTabFromRoute()
      if (!typeChanged) return

      if (!route.params.tag) {
        currentSelectedTag.value = 'all'
      }
      reset()
      await getNewsTime(activeType.value as string)
    },
  )

  const tagMap = {
    'maritime-news': 'maritime',
    ports: 'port',
    globallogistics: 'globallogistics',
  }

  function slugToLabel(slug = '') {
    if (!slug) return ''
    if (tagMap[slug]) return tagMap[slug]
    const altKey = slug.replace(/_/g, '-')
    if (tagMap[altKey]) return tagMap[altKey]
    const words = slug
      .replace(/^[_-]+|[_-]+$/g, '')
      .split(/[_-]+/)
      .filter(Boolean)
    return words.map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join(' ')
  }

  useAsyncData('seoGetNewsList', async () => {
    await getTagData()
    await getNewsTime(activeType.value as string)
    return {}
  })

  // 这里改动了：彻底重构了 SEO Watcher 逻辑，完美对接你提供的 TDK 文案要求
  watch(
    () => route.params.tag,
    () => {
      let title = ''
      let keywords = ''
      let description = ''
      const normTag = normalizeToSlug(String(route.params?.tag))
      const currentTag = buttons.value.find((button) => {
        const en = normalizeToSlug(String(button.keywordEn || ''))
        return en === normTag
      })

      // 有 Tag 时走的动态逻辑
      if (route.params?.tag && route.params?.tag !== 'all' && currentTag) {
        let keywordCn = currentTag?.keywordCn
        const keywordWithoutNews = keywordCn?.replace(/新闻$/, '')
        let keywordEn = currentTag.keywordEn

        title = isCn.value
          ? `${keywordCn}-了解${keywordCn}相关国际货运代理与供应链资讯-JCtrans杰西圈`
          : `${keywordEn} news - Learn About ${keywordEn}-Related International Freight Forwarding & supply chain News -JCtrans`
        if (activeType.value === 'jctransNews') {
          title = isCn.value
            ? `${keywordCn}-了解JCtrans${keywordCn}相关国际货运代理与供应链资讯-JCtrans杰西圈`
            : `${keywordEn} news - Learn About ${keywordEn}-Related International Freight Forwarding & supply chain News -JCtrans`
        } else if (
          activeType.value !== 'logisticsNews' &&
          activeType.value !== 'jctransNews'
        ) {
          if (activeType.value === 'jctransNews') {
            title = isCn.value
              ? `Jctrans展会与公司新闻-提供全球货代&物流行业动态-JCtrans杰西圈`
              : `JCtrans News- Freight Forwarding & Logistics Industry Insights & Events`
            keywords = isCn.value
              ? `货代行业洞察,货运代理动态`
              : `Freight Forwarding Industry Insights, Freight Forwarding Dynamics`
            description = isCn.value
              ? `JCtrans新闻,获取全球货代网络B2B平台的最新动态、展会、政策变化及平台公告。定期发布深度报道和行业洞察,助力货代企业把握趋势、洞察商机,拓展国际合作网络。`
              : `JCtrans regularly publishes in-depth reports and industry insights to help freight forwarding companies grasp trends and expand their international cooperation networks.`
          } else if (activeType.value === 'knowledgeNews') {
            title = isCn.value
              ? `国际货运知识百科_物流术语大全及实操流程指南 - JCtrans杰西圈`
              : `Logistics Wiki & Freight Glossary | International Shipping Guides - JCtrans`
            keywords = isCn.value
              ? `货运知识, 物流百科, 国际贸易术语, 货运实操, 物流术语大全`
              : `Logistics Wiki, Freight Glossary, Shipping Terms, International Trade Guides`
            description = isCn.value
              ? `JCtrans杰西圈货运知识百科为您提供全面、专业的国际物流术语解析。涵盖海运/空运基础知识、贸易术语(Incoterms)、报关清关流程及各类单据规范，助力外贸货代新手快速进阶。`
              : `Explore JCtrans Logistics Wiki for comprehensive definitions of shipping terms, Incoterms, and customs procedures. Master international freight operations with our expert guides and industry best practices.`
          }
          // 👇 新增：货运区域 SEO
          else if (activeType.value === 'regionsNews') {
            title = isCn.value
              ? `货运指南_当地货运成本、海关流程及风土人情- JCtrans杰西圈`
              : `Freight Guide- Local Freight Costs, Customs Procedures, and Customs - JCtrans`
            keywords = isCn.value
              ? `货运成本, 海关流程, 贸易习惯, 跨境物流指南, 当地风土人情`
              : `Freight costs, customs procedures, trade practices, cross-border logistics guide, local customs and culture`
            description = isCn.value
              ? `JCtrans杰西圈涵盖当地货运成本构成、海关清关流程及禁限运规定。同时为您提供当地商务风土人情与贸易习惯指南，助力企业降低海外沟通成本与物流风控。`
              : `JCtrans provides information on local freight cost breakdowns, customs clearance procedures, and prohibited/restricted transport regulations. It also offers guides to local business customs and trade practices to help businesses reduce overseas communication costs and manage logistics risks.`
          }
          // 👇 新增：货运经验 SEO
          else if (activeType.value === 'experienceNews') {
            title = isCn.value
              ? `国际货运实战经验_货代避坑指南与行业案例 - JCtrans杰西圈`
              : `Real-World Shipping Experience | Freight Forwarding Pitfalls & Case Studies - JCtrans`
            keywords = isCn.value
              ? `货运经验, 物流案例, 货代实战, 货运避坑, 国际物流技巧`
              : `Shipping Experience, Logistics Case Studies, Freight Forwarding Insights, Avoiding Shipping Pitfalls, International Logistics Tips`
            description = isCn.value
              ? `汇聚全球资深货代实战经验，深度解析国际物流中的清关难点、运输损耗及合同规避风险。通过真实货运案例分享，帮助外贸企业提升物流风控能力，掌握行业一线实操技巧。`
              : `Gather firsthand shipping insights from global senior freight forwarders. Deep dive into international logistics challenges including customs clearance, transit damage, and contract risk mitigation. Leverage real-world case studies to enhance logistics risk management and master firsthand operational tips.`
          }
          // 👇 新增：货运解决方案 SEO (注：中文Title原稿未提供，此为结合英文意译补充)
          else if (activeType.value === 'solutionsNews') {
            title = isCn.value
              ? `国际货运解决方案与跨境物流定制服务 - JCtrans杰西圈`
              : `International Freight Solutions & Cross-Border Logistics Services - JCtrans`
            keywords = isCn.value
              ? `货运解决方案, 跨境物流方案, 货运定制服务, 危险品运输, 冷链物流`
              : `Freight Solutions, Cross-Border Logistics, Tailored Shipping Services, Dangerous Goods Transport, Cold Chain Logistics`
            description = isCn.value
              ? `JCtrans提供全方位国际货运解决方案，涵盖特种柜运输、超大货物物流、冷链生鲜及危险品货运等定制化服务。汇聚全球优质货代资源，为您优化物流成本，规避运输风险。`
              : `JCtrans provides comprehensive international freight solutions, including specialty container shipping (OOG), project cargo, cold chain, and hazardous materials logistics. Access global premium freight forwarder resources to optimize shipping costs and ensure risk mitigation.`
          }
          // 👇 新增：货运政策 SEO
          else if (activeType.value === 'policyNews') {
            title = isCn.value
              ? `全球货运政策法规_国际物流进出口规定及海关新规-JCtrans杰西圈`
              : `Global Freight Policy & Regulations-International Logistics & Customs Updates - JCtrans`
            keywords = isCn.value
              ? `货运政策, 海关新规, 国际物流规定, 附加费标准, 贸易限制, 货运合规`
              : `Freight Policy, Customs Regulations, International Shipping Rules, Shipping Surcharge Standards, Trade Restrictions, Logistics Compliance`
            description = isCn.value
              ? `JCtrans杰西圈提供全球货运政策查询，涵盖国际海关清关新规、船公司燃油附加费(BAF)、旺季附加费(PSS)及低硫费(LSS)最新标准。汇总各国进出口贸易限制、航线管制及货运合规指南，助力外贸货代企业掌握物流成本变动。`
              : `JCtrans provides real-time global freight policy updates, covering international customs regulations and the latest shipping surcharges including BAF, PSS, and LSS. Access a comprehensive database of import/export trade restrictions, route advisories, and logistics compliance guides to stay ahead of shipping cost fluctuations.`
          }
        }

        keywords = isCn.value
          ? `国际货运代理`
          : `International freight forwarding`
        description = isCn.value
          ? `关注${keywordWithoutNews}新闻资讯,获取全球货代、国际物流、供应链和货运代理行业的最新动态、市场分析、政策变化及平台公告,助力货代企业更好实现国际交流、合作洽谈和资源对接。`
          : `Stay Updated on ${keywordEn} News - Get the Latest insights on Global FreightForwarding, supply Chain, Freight Industry Trends, Market Analysis, Policy Changes & PlatformAnnouncements, Empowering Freight Forwarders for Better international Communication.Collaboration, and Resource Matching.`
      }
      // 没有 Tag 时的各独立模块 TDK 定义
      else {
        if (activeType.value === 'logisticsNews') {
          title = isCn.value
            ? `货代新闻-了解全球物流获得行业及会员的所有最新动态新闻-JCtrans杰西圈`
            : `Global Freight News-Logistics & supply chain Trends-Jctrans`
          keywords = isCn.value
            ? `JCtrans新闻,货代新闻,国际物流新闻,供应链动态,货运代理资讯,全球货代动态,物流行业新闻`
            : `Freight Forwarding News, International Logistics News, Global Freight Forwarding, Logistics Industry`
          description = isCn.value
            ? `关注 JCtrans新闻资讯,获取全球货代、国际物流、供应链和货运代理行业的最新动态、市场分析、政策变化及平台公告,助力货代企业更好实现国际交流、合作洽谈和资源对接。`
            : `Follow JCtrans news and information to get the latest updates, market analysis, policy changes, and platform announcements from the global freight forwarding, international logistics, supply chain, and freight forwarding industry.`
        } else if (activeType.value === 'jctransNews') {
          title = isCn.value
            ? `Jctrans展会与公司新闻-提供全球货代&物流行业动态-JCtrans杰西圈`
            : `JCtrans News- Freight Forwarding & Logistics Industry Insights & Events`
          keywords = isCn.value
            ? `货代行业洞察,货运代理动态`
            : `Freight Forwarding Industry Insights, Freight Forwarding Dynamics`
          description = isCn.value
            ? `JCtrans新闻,获取全球货代网络B2B平台的最新动态、展会、政策变化及平台公告。定期发布深度报道和行业洞察,助力货代企业把握趋势、洞察商机,拓展国际合作网络。`
            : `JCtrans regularly publishes in-depth reports and industry insights to help freight forwarding companies grasp trends and expand their international cooperation networks.`
        } else if (activeType.value === 'knowledgeNews') {
          title = isCn.value
            ? `国际货运知识百科_物流术语大全及实操流程指南 - JCtrans杰西圈`
            : `Logistics Wiki & Freight Glossary | International Shipping Guides - JCtrans`
          keywords = isCn.value
            ? `货运知识, 物流百科, 国际贸易术语, 货运实操, 物流术语大全`
            : `Logistics Wiki, Freight Glossary, Shipping Terms, International Trade Guides`
          description = isCn.value
            ? `JCtrans杰西圈货运知识百科为您提供全面、专业的国际物流术语解析。涵盖海运/空运基础知识、贸易术语(Incoterms)、报关清关流程及各类单据规范，助力外贸货代新手快速进阶。`
            : `Explore JCtrans Logistics Wiki for comprehensive definitions of shipping terms, Incoterms, and customs procedures. Master international freight operations with our expert guides and industry best practices.`
        }
        // 👇 新增：货运区域 SEO
        else if (activeType.value === 'regionsNews') {
          title = isCn.value
            ? `货运指南_当地货运成本、海关流程及风土人情- JCtrans杰西圈`
            : `Freight Guide- Local Freight Costs, Customs Procedures, and Customs - JCtrans`
          keywords = isCn.value
            ? `货运成本, 海关流程, 贸易习惯, 跨境物流指南, 当地风土人情`
            : `Freight costs, customs procedures, trade practices, cross-border logistics guide, local customs and culture`
          description = isCn.value
            ? `JCtrans杰西圈涵盖当地货运成本构成、海关清关流程及禁限运规定。同时为您提供当地商务风土人情与贸易习惯指南，助力企业降低海外沟通成本与物流风控。`
            : `JCtrans provides information on local freight cost breakdowns, customs clearance procedures, and prohibited/restricted transport regulations. It also offers guides to local business customs and trade practices to help businesses reduce overseas communication costs and manage logistics risks.`
        }
        // 👇 新增：货运经验 SEO
        else if (activeType.value === 'experienceNews') {
          title = isCn.value
            ? `国际货运实战经验_货代避坑指南与行业案例 - JCtrans杰西圈`
            : `Real-World Shipping Experience | Freight Forwarding Pitfalls & Case Studies - JCtrans`
          keywords = isCn.value
            ? `货运经验, 物流案例, 货代实战, 货运避坑, 国际物流技巧`
            : `Shipping Experience, Logistics Case Studies, Freight Forwarding Insights, Avoiding Shipping Pitfalls, International Logistics Tips`
          description = isCn.value
            ? `汇聚全球资深货代实战经验，深度解析国际物流中的清关难点、运输损耗及合同规避风险。通过真实货运案例分享，帮助外贸企业提升物流风控能力，掌握行业一线实操技巧。`
            : `Gather firsthand shipping insights from global senior freight forwarders. Deep dive into international logistics challenges including customs clearance, transit damage, and contract risk mitigation. Leverage real-world case studies to enhance logistics risk management and master firsthand operational tips.`
        }
        // 👇 新增：货运解决方案 SEO (注：中文Title原稿未提供，此为结合英文意译补充)
        else if (activeType.value === 'solutionsNews') {
          title = isCn.value
            ? `国际货运解决方案与跨境物流定制服务 - JCtrans杰西圈`
            : `International Freight Solutions & Cross-Border Logistics Services - JCtrans`
          keywords = isCn.value
            ? `货运解决方案, 跨境物流方案, 货运定制服务, 危险品运输, 冷链物流`
            : `Freight Solutions, Cross-Border Logistics, Tailored Shipping Services, Dangerous Goods Transport, Cold Chain Logistics`
          description = isCn.value
            ? `JCtrans提供全方位国际货运解决方案，涵盖特种柜运输、超大货物物流、冷链生鲜及危险品货运等定制化服务。汇聚全球优质货代资源，为您优化物流成本，规避运输风险。`
            : `JCtrans provides comprehensive international freight solutions, including specialty container shipping (OOG), project cargo, cold chain, and hazardous materials logistics. Access global premium freight forwarder resources to optimize shipping costs and ensure risk mitigation.`
        }
        // 👇 新增：货运政策 SEO
        else if (activeType.value === 'policyNews') {
          title = isCn.value
            ? `全球货运政策法规_国际物流进出口规定及海关新规-JCtrans杰西圈`
            : `Global Freight Policy & Regulations-International Logistics & Customs Updates - JCtrans`
          keywords = isCn.value
            ? `货运政策, 海关新规, 国际物流规定, 附加费标准, 贸易限制, 货运合规`
            : `Freight Policy, Customs Regulations, International Shipping Rules, Shipping Surcharge Standards, Trade Restrictions, Logistics Compliance`
          description = isCn.value
            ? `JCtrans杰西圈提供全球货运政策查询，涵盖国际海关清关新规、船公司燃油附加费(BAF)、旺季附加费(PSS)及低硫费(LSS)最新标准。汇总各国进出口贸易限制、航线管制及货运合规指南，助力外贸货代企业掌握物流成本变动。`
            : `JCtrans provides real-time global freight policy updates, covering international customs regulations and the latest shipping surcharges including BAF, PSS, and LSS. Access a comprehensive database of import/export trade restrictions, route advisories, and logistics compliance guides to stay ahead of shipping cost fluctuations.`
        }
      }

      useHead({
        title: title,
        meta: [
          { name: 'description', content: description },
          { name: 'keywords', content: keywords },
        ],
        titleTemplate: null,
      })
    },
    { immediate: true },
  )

  function reset(resetParams = true) {
    loadStatus.value = false
    newsList.value = [
      {
        label: 'knowledge.logistics_news',
        content: '',
        list: [],
        key: 'logisticsNews',
      },
      {
        label: 'knowledge.jctrans_news',
        content: '',
        list: [],
        key: 'jctransNews',
      },
      {
        label: 'knowledge.freight_knowledge',
        content: '',
        list: [],
        key: 'knowledgeNews',
      },
      // 这里改动了：确保重置时 4 个新分类也在里面
      {
        label: 'knowledge.freight_area',
        content: '',
        list: [],
        key: 'regionsNews',
      },
      {
        label: 'knowledge.freight_experience',
        content: '',
        list: [],
        key: 'experienceNews',
      },
      {
        label: 'knowledge.freight_solutions',
        content: '',
        list: [],
        key: 'solutionsNews',
      },
      {
        label: 'knowledge.freight_policy',
        content: '',
        list: [],
        key: 'policyNews',
      },
    ]

    if (resetParams) {
      logisticsParams.value = { current: 1, size: 6, total: 0, keywordId: null }
      jctransParams.value = { current: 1, size: 6, total: 0, keywordId: null }
      knowledgeParams.value = { current: 1, size: 6, total: 0, keywordId: null }
      // 这里改动了：清空新加分类的参数
      regionsParams.value = { current: 1, size: 6, total: 0, keywordId: null }
      experienceParams.value = {
        current: 1,
        size: 6,
        total: 0,
        keywordId: null,
      }
      solutionsParams.value = { current: 1, size: 6, total: 0, keywordId: null }
      policyParams.value = { current: 1, size: 6, total: 0, keywordId: null }
    }
  }

  async function changeTab(e: any) {
    reset()
    currentSelectedTag.value = 'all'

    // 这里改动了：补充了对新加入的 Tab 的映射判断
    if (e.name === 0) {
      activeType.value = 'logisticsNews'
      await navigateTo({ name: 'logisticsNews', replace: true })
    } else if (e.name === 1) {
      activeType.value = 'jctransNews'
      await navigateTo({ name: 'jctransNews', replace: true })
    } else if (e.name === 2) {
      activeType.value = 'knowledgeNews'
      await navigateTo({ name: 'knowledgeNews', replace: true })
    } else if (e.name === 3) {
      activeType.value = 'regionsNews'
      await navigateTo({ name: 'regionsNews', replace: true })
    } else if (e.name === 4) {
      activeType.value = 'experienceNews'
      await navigateTo({ name: 'experienceNews', replace: true })
    } else if (e.name === 5) {
      activeType.value = 'solutionsNews'
      await navigateTo({ name: 'solutionsNews', replace: true })
    } else if (e.name === 6) {
      activeType.value = 'policyNews'
      await navigateTo({ name: 'policyNews', replace: true })
    }

    // reportCallBack(
    //   {
    //     eventCode: 'NEWS.TYPE.CLICK',
    //     extensions: {
    //       TYPE: activeType.value,
    //     },
    //   },
    //   undefined,
    //   'CLICK',
    // )
    const key = newsList.value.find(
      (item) => item.key === activeType.value,
    )?.label
    $trackEvent('clickPage', {
      pageCode_var: route.meta.pageCode,
      modulePosition_var: '-',
      moduleType_var: '-',
      moduleName_var: `新闻tab点击`,
      pageClickName_var: $t(key, {}, { locale: 'zh-CN' }),
      $title: '-',
    })
    await getNewsTime(activeType.value as string)
  }

  async function handleClickTag(e: any) {
    const currentKeyword = e?.name || 'all'
    reset()
    currentSelectedTag.value = currentKeyword
    const keywordIdVal = currentKeyword === 'all' ? '' : currentKeyword
    logisticsParams.value.keywordId = keywordIdVal
    jctransParams.value.keywordId = keywordIdVal
    knowledgeParams.value.keywordId = keywordIdVal
    regionsParams.value.keywordId = keywordIdVal
    experienceParams.value.keywordId = keywordIdVal
    solutionsParams.value.keywordId = keywordIdVal
    policyParams.value.keywordId = keywordIdVal

    const currentTag = buttons.value.find((item: any) => item.id === e.name)
    if (currentKeyword === 'all') {
      if (activeType.value === 'jctransNews')
        navigateTo({ name: 'jctransNews', replace: true })
      else if (activeType.value === 'knowledgeNews')
        navigateTo({ name: 'knowledgeNews', replace: true })
      else if (activeType.value === 'regionsNews')
        navigateTo({ name: 'regionsNews', replace: true })
      else if (activeType.value === 'experienceNews')
        navigateTo({ name: 'experienceNews', replace: true })
      else if (activeType.value === 'solutionsNews')
        navigateTo({ name: 'solutionsNews', replace: true })
      else if (activeType.value === 'policyNews')
        navigateTo({ name: 'policyNews', replace: true })
      else navigateTo({ name: 'logisticsNews', replace: true })
    } else {
      const slug = normalizeToSlug(
        currentTag?.keywordEn || currentTag?.keywordCn || '',
      )
      let basePath = NEW_ROUTE_MAP.logisticsNews
      if (activeType.value === 'jctransNews')
        basePath = NEW_ROUTE_MAP.jctransNews
      else if (activeType.value === 'knowledgeNews')
        basePath = NEW_ROUTE_MAP.knowledge
      else if (activeType.value === 'regionsNews') basePath = '/news-regions/'
      else if (activeType.value === 'experienceNews')
        basePath = '/news-experience/'
      else if (activeType.value === 'solutionsNews')
        basePath = '/news-solutions/'
      else if (activeType.value === 'policyNews') basePath = '/news-policy/'

      navigateTo({
        path: `${prefix.value}${buildTagPath(basePath, slug)}`,
        replace: true,
      })
    }

    try {
      let currentEventCode = 'ERA.UC.NEWS.NEWS.Tag'
      if (activeType.value === 'jctransNews')
        currentEventCode = 'ERA.UC.NEWS.JCTRANS.Tag'
      else if (activeType.value === 'knowledgeNews')
        currentEventCode = 'ERA.UC.NEWS.KNOWLEDGE.Tag'
      else if (activeType.value === 'regionsNews')
        currentEventCode = 'ERA.UC.NEWS.REGIONS.Tag'
      else if (activeType.value === 'experienceNews')
        currentEventCode = 'ERA.UC.NEWS.EXPERIENCE.Tag'
      else if (activeType.value === 'solutionsNews')
        currentEventCode = 'ERA.UC.NEWS.SOLUTIONS.Tag'
      else if (activeType.value === 'policyNews')
        currentEventCode = 'ERA.UC.NEWS.POLICY.Tag'

      const key = newsList.value.find(
        (item) => item.key === activeType.value,
      )?.label
      $trackEvent('clickPage', {
        pageCode_var: route.meta.pageCode,
        modulePosition_var: '-',
        moduleType_var: '-',
        moduleName_var: `${$t(key, {}, { locale: 'zh-CN' })}子tab点击`,
        pageClickName_var: currentTag?.keywordCn || '全部',
        $title: '-',
      })
      await getNewsTime(activeType.value as string)
    } catch (error) {
      console.error('Error while reporting tag click API:', error)
    }
  }

  // 这里改动了：支持详情页的点击路由分发
  function toNewsDetail(item: any, type: string) {
    let path = ''
    if (type === 'jctransNews') path = `${prefix.value}/jctransnews/${item.id}/`
    else if (type === 'knowledgeNews')
      path = `${prefix.value}/news-knowledge/${item.id}/`
    else if (type === 'regionsNews')
      path = `${prefix.value}/news-regions/${item.id}/`
    else if (type === 'experienceNews')
      path = `${prefix.value}/news-experience/${item.id}/`
    else if (type === 'solutionsNews')
      path = `${prefix.value}/news-solutions/${item.id}/`
    else if (type === 'policyNews')
      path = `${prefix.value}/news-policy/${item.id}/`
    else path = `${prefix.value}/news/${item.id}/`
    navigateTo({ path: path })
  }

  watch(
    () => currentSelectedTag.value,
    (newVal) => {
      if (newVal) {
        logisticsParams.value.keywordId = newVal
        jctransParams.value.keywordId = newVal
        knowledgeParams.value.keywordId = newVal
        // 这里改动了：联动新加模块
        regionsParams.value.keywordId = newVal
        experienceParams.value.keywordId = newVal
        solutionsParams.value.keywordId = newVal
        policyParams.value.keywordId = newVal
      }
    },
    { immediate: false },
  )

  watch(
    () => bottom.value,
    (newVal) => {
      if (newVal) {
        // 这里改动了：添加触底分页获取对应类型数据的支撑
        let currentList = newsList.value[0]
        let currentParams = logisticsParams.value
        let fetchFn = getLogisticsNews

        if (activeType.value === 'jctransNews') {
          currentList = newsList.value[1]
          currentParams = jctransParams.value
          fetchFn = getJctransNews
        } else if (activeType.value === 'knowledgeNews') {
          currentList = newsList.value[2]
          currentParams = knowledgeParams.value
          fetchFn = getKnowledgeNews
        } else if (activeType.value === 'regionsNews') {
          currentList = newsList.value[3]
          currentParams = regionsParams.value
          fetchFn = getRegionsNews
        } else if (activeType.value === 'experienceNews') {
          currentList = newsList.value[4]
          currentParams = experienceParams.value
          fetchFn = getExperienceNews
        } else if (activeType.value === 'solutionsNews') {
          currentList = newsList.value[5]
          currentParams = solutionsParams.value
          fetchFn = getSolutionsNews
        } else if (activeType.value === 'policyNews') {
          currentList = newsList.value[6]
          currentParams = policyParams.value
          fetchFn = getPolicyNews
        }

        const len = currentList?.list.length || 0
        if (len < currentParams.total) {
          currentParams.current += 1
          fetchFn()
        }
      }
    },
  )
</script>

<style lang="scss" scoped>
  .knowledge-news {
    background: #f5f5f5;

    .top-content {
      height: 140px;
      padding-top: 34px;
      padding-left: 17px;
      background-image: url('https://resources.jctrans.com/res/era/pc/img/banner_news.jpg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;

      .top-content-title {
        height: 33px;
        font-family: Poppins-B, Poppins;
        font-size: 22px;
        font-weight: bold;
        line-height: 26px;
        color: #232324;
      }

      .top-content-desc {
        width: 240px;
        margin-top: 4px;
        font-family: Poppins-R, Poppins;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: 13px;
        color: #5e5f64;
      }
    }

    .news-content {
      padding: 16px;

      .news-main-tab {
        :deep(.van-tabs__wrap) {
          height: 40px;
        }

        :deep(.van-tabs__nav--card) {
          height: 40px;
          padding: 4px;
          margin: 0;
          border: none;
          border-radius: 8px;

          overflow-x: auto;
          overflow-y: hidden;
          flex-wrap: nowrap;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
          &::-webkit-scrollbar {
            display: none;
          }

          .van-tab {
            border-right: none !important;
          }
        }

        :deep(.asdasdasdas) {
          font-family: Poppins-S;
          font-size: 12px;
          font-weight: 600;
          border-radius: 6px;

          flex: 1 0 auto !important;
          padding: 0 16px;
        }
      }

      .news-tag {
        width: fit-content;
        min-width: 100px;
        padding: 0 8px;
        height: 20px;
        white-space: nowrap;
        font-family: Poppins-R, Poppins;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        color: #bd5339;
        background: linear-gradient(270deg, #fae5cd 0%, #f4be9c 100%);
        border-radius: 2px;
        flex-shrink: 0;
      }
    }
  }
</style>
